import React, { useContext, useState } from 'react';
import './report-container.scss';
import UploadModalContent from '../modal/upload-modal/upload-modal';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ReportsService from '../../../../../../services/reports-service';

const ReportContainer = ({ filteredReports = [], handleCheckboxChange }) => {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  
  const reportService = new ReportsService(); 

  const handleUploadClick = (report) => {
    setSelectedReport(report);
    setShowUploadModal(true);
  };

  const handleCloseModal = () => {
    setShowUploadModal(false);
    setSelectedReport(null);
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortedReports = [...filteredReports].sort((a, b) => {
    if (sortConfig.key) {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      // Convert string dates to Date objects for comparison
      if (sortConfig.key === 'paymentDate' || sortConfig.key === 'dateSubmitted') {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      if (aValue < bValue) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
    }
    return 0;
  });

  // Handle the preview action
  const handlePreviewClick = async (report) => {
    console.log(report);
    try {
      const response = await reportService.retrieveReport(report.type, report.isin, report.title, report.paymentDate);
      console.log(response);
      const newWindow = window.open(response.fileURL, '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
    } catch (error) {
      console.error('Error fetching report preview:', error.message);
    }
  };

  // Handle the download action
  const handleDownloadClick = async (report) => {
    try {
        const response = await reportService.retrieveReport(report.type, report.isin, report.title, report.paymentDate);
        
        const fileResponse = await fetch(response.fileURL);
        if (!fileResponse.ok) throw new Error('Network response was not ok');

        const blob = await fileResponse.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        // Use the file name provided by the server
        const fileName = response.fileName || 'download.pdf'; // Fallback if fileName is not available
        link.href = objectUrl;
        link.download = fileName; // Set the download attribute to the expected file name
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
        console.error('Error downloading report:', error.message);
    }
  };

  return (
    <div className="table-container">
      <table className="report-table">
        <thead>
          <tr>
            <th className="checkbox-header"></th>
            <th>Report Title</th>
            <th>Issuer</th>
            <th>ISIN</th>
            <th onClick={() => handleSort('paymentDate')}>
              Payment Date {sortConfig.key === 'paymentDate' && (sortConfig.direction === 'ascending' ? '▲' : '▼')}
            </th>
            <th>Status</th>
            <th onClick={() => handleSort('dateSubmitted')}>
              Date Submitted {sortConfig.key === 'dateSubmitted' && (sortConfig.direction === 'ascending' ? '▲' : '▼')}
            </th>
            <th>Issuer Receipt Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedReports.map(report => (
            <tr key={report.id}>
              <td className="checkbox-cell">
                {report.status === 'For Checking' ? (
                  <input 
                    type="checkbox" 
                    onChange={() => handleCheckboxChange(report.id)} 
                  />
                ) : null}
              </td>
              <td>{report.title}</td>
              <td>{report.issuer}</td>
              <td>{report.isin}</td>
              <td>{report.paymentDate}</td>
              <td className={`status ${report.status.replace(' ', '-').toLowerCase()}`}>{report.status}</td>
              <td>{report.dateSubmitted}</td>
              <td>{report.issuerReceiptDate}</td>
              <td>
                <div className="action-buttons">
                  <Button variant="primary" className="action-button" onClick={() => handlePreviewClick(report)}>Preview</Button>
                  <Button variant="primary" className="action-button" onClick={() => handleDownloadClick(report)}>Download</Button>
                  {report.status === 'For Checking' && (
                    <Button variant="primary" className="action-button" onClick={() => handleUploadClick(report)}>Upload</Button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Render the Upload Modal */}
      {selectedReport && (
        <Modal show={showUploadModal} onHide={handleCloseModal} dialogClassName='checker-upload-modal'>
          <Modal.Header closeButton>
            <Modal.Title>Upload Document</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <UploadModalContent context={{ report: selectedReport }} onClose={handleCloseModal} />
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default ReportContainer;
